function updateCartToggleText() {

	const cartToggle = document.querySelector(".zny-header__cart__toggle");

	if (!cartToggle) return;

	if (document.body.classList.contains("js-show-ajax-cart")) {

		cartToggle.textContent = "Close";

	} else {

		const cartCount = document.querySelector("[data-ajax-cart-bind='item_count']")?.textContent || 0;

		cartToggle.innerHTML = `
			<span>Bag</span>
			(<span data-ajax-cart-bind="item_count" class="header__cart-quantity">${cartCount}</span>)
		`;

	}

}

function runWhenInit() {
	console.log("The current cart state is: ", window.liquidAjaxCart.cart);
	updateCartToggleText();
}

if (window.liquidAjaxCart?.init) {

	runWhenInit();

} else {

	document.addEventListener("liquid-ajax-cart:init", runWhenInit);

}

// Open cart after add to cart
document.addEventListener("liquid-ajax-cart:request-end", event => {

	const { requestState } = event.detail;

	if (
		requestState.requestType === "add" &&
		requestState.responseData?.ok
	) {

		requestAnimationFrame(() => {

			document.body.classList.add("js-show-ajax-cart");
			updateCartToggleText();

		});

	}

});

// Toggle cart open/close
document.addEventListener("click", function (e) {

	const toggle = e.target.closest(".zny-header__cart__toggle, .zny-mobile__header__cart-toggle, .zny-mini__cart__close button");

	if (toggle) {

		document.body.classList.toggle("js-show-ajax-cart");
		updateCartToggleText();

	}

});